import React, {useState, useEffect} from 'react';
import AppBar from "../components/app_bar/AppBar";
import Drawer from "../components/Drawer";
import { 
    Typography, CssBaseline, Box, Toolbar, Grid, Card, CardContent, useMediaQuery,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTheme } from '@mui/material/styles';
import { useParams } from "react-router-dom";

import * as CONSTANTS from "../constants"

const getFormByStatusCode = (success, lang) => {
    const iconStyle = {
        transition: 'transform 0.5s, opacity 0.5s',
        display: 'inline-block',
    };
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                padding: 2,
            }}
        >
            {success === null && (
                <CircularProgress size={40} color="primary" style={iconStyle} />
            )}
            {success === true && (
                <CheckCircleIcon
                style={{
                    ...iconStyle,
                    transform: 'scale(1.2)',
                }}
                color="success"
                />
            )}
            {success === false && (
                <CancelIcon
                    style={{
                        ...iconStyle,
                        transform: 'scale(1.2)',
                    }}
                    color="error"
                />
            )}
            <Typography variant="h6" sx={{ marginTop: 1 }}>
                {success === null
                ? CONSTANTS.VERIFY_EMAIL.MESSAGE.VERIFYING[lang]
                : success === true
                ? CONSTANTS.VERIFY_EMAIL.MESSAGE.VERIFY_SUCCESSFUL[lang]
                : success === false
                ? CONSTANTS.VERIFY_EMAIL.MESSAGE.VERIFY_FAILED[lang]
                : ''}
            </Typography>
        </Box>
    );
}

const VerifyEmail = () => {

    document.title = `Verify Email - Wotagei Zone`

    let {lang, token} = useParams();

    const [drawerOpen, setDrawerOpen] = useState(false);

    const handleDrawerOpen = (open) => {
        if (open === undefined) {
            setDrawerOpen(!drawerOpen)
        } else {
            setDrawerOpen(open);
        }
    }

    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        const verifyAccount = async () => {
            try {
                const response = await fetch(`/api/user/verify/${token}`);
                if (response.ok) {
                    setSuccess(true);
                    setMessage('Your account has been verified!');
                } else {
                const data = await response.json();
                    setSuccess(false);
                    setMessage(data.error || 'Failed to verify account.');
                }
            } catch (error) {
                setSuccess(false);
                setMessage('An error occurred.');
            }
        };

        verifyAccount();
    }, [token]);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    return (
        <Box >
            <CssBaseline />
            <AppBar lang={lang} handleDrawerOpen={handleDrawerOpen}/>
            <Box sx={{ display: 'flex' }}>
                <Drawer lang={lang} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                <Box component="main" sx={{ flexGrow: 1, p: isMobile? 2: 3}}>
                    <Toolbar />
                    <Grid container spacing={2} style={{ height: '80vh' }}>
                        <Grid item xs={12} alignContent={'center'} justifyItems={'center'} >
                            <Card
                                sx={{
                                    width: '25vw',
                                    padding: '3vw',
                                    minWidth: "300px",
                                }}
                            >
                                {getFormByStatusCode(success, lang)}
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};
 
export default VerifyEmail;